/**
 * First run with no backend configured.
 *
 * A missing `.env` is a setup step, not a crash — someone cloning this repo to
 * read the domain module or run the calculator should not meet a white screen.
 */
export default function Setup() {
  return (
    <main className="app-shell stack">
      <p className="eyebrow">Fortunaut</p>
      <h1>Nearly there</h1>
      <p className="muted">
        The app needs a Supabase project before it can hold a family. Copy{' '}
        <code>.env.example</code> to <code>.env</code>, fill in the two values from your
        project settings, and restart the dev server.
      </p>
      <div className="card stack tight">
        <p className="small muted">
          The anon key is public by design. Row-level security is what protects the data —
          see <code>supabase/migrations/0001_family_foundation.sql</code>.
        </p>
      </div>
      <p className="small muted">
        The money rules don’t need any of this. <code>npm test</code> runs the whole domain
        suite with no network and no database.
      </p>
    </main>
  );
}
